// 페이지 가이드 투어 레지스트리
// 페이지 추가 시: tours/<key>Tour.js 작성 후 여기에 한 줄 등록하면 끝.
// (라우트 키 = common.getCurNav().submenu.name)
import { buildReviewListSteps } from './tours/reviewListTour';
import { buildReviewWriteSteps } from './tours/reviewWriteTour';
import { buildReviewMassWriteSteps } from './tours/reviewMassWriteTour';
import { buildReviewWriteConfigSteps } from './tours/reviewWriteConfigTour';
import { buildEasySettingSteps } from './tours/easySettingTour';
import {
  buildRwcDetailWidgetSteps, buildRwcCafe24Steps, buildRwcWriteSteps, buildRwcDesignSteps,
  buildRwcCommentSteps, buildRwcDisplaySteps, buildRwcReviewRatingCountSteps,
  buildRwcProductListSteps, buildRwcCssSteps,
} from './tours/reviewWriteConfigSections';

const REGISTRY = {
  reviewList: buildReviewListSteps,
  reviewWrite: buildReviewWriteSteps,
  reviewMassWrite: buildReviewMassWriteSteps,
  reviewWriteConfig: buildReviewWriteConfigSteps,
  easySetting: buildEasySettingSteps,
  // 섹션별 세부 가이드 (각 박스 ? 클릭) — 'reviewWriteConfig:<섹션key>'(섹션key = openRwcSection 값)
  'reviewWriteConfig:detailWidget': buildRwcDetailWidgetSteps,
  'reviewWriteConfig:cafe24': buildRwcCafe24Steps,
  'reviewWriteConfig:write': buildRwcWriteSteps,
  'reviewWriteConfig:design': buildRwcDesignSteps,
  'reviewWriteConfig:comment': buildRwcCommentSteps,
  'reviewWriteConfig:display': buildRwcDisplaySteps,
  'reviewWriteConfig:reviewRatingCount': buildRwcReviewRatingCountSteps,
  'reviewWriteConfig:productList': buildRwcProductListSteps,
  'reviewWriteConfig:css': buildRwcCssSteps,
};

// 해당 라우트에 등록된 투어가 있는지 (PageTitle의 ? 버튼 노출 판정)
export const hasTour = (key) => !!(key && REGISTRY[key]);

// 투어 스텝 빌더 반환
export const getTourBuilder = (key) => (key && REGISTRY[key]) || null;

export default REGISTRY;
